import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "reservation_m"
};
const _hoisted_2 = {
  class: "reservation_box_m"
};
const _hoisted_3 = {
  class: "info-box"
};
const _hoisted_4 = {
  class: "nav-box"
};
const _hoisted_5 = {
  class: "aq-box"
};
const _hoisted_6 = {
  class: "aq-p"
};
const _hoisted_7 = {
  class: "aq-p"
};
const _hoisted_8 = {
  class: "aq-p"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("h1", null, "立即申请预约，了解更多详细信息", -1)), _createElementVNode("button", {
    class: "reservation_btn_m",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.show && $setup.show(...args))
  }, " 点击预约 ")])]), _createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "code-box"
  }, [_createElementVNode("div", {
    class: "code"
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/code2.png",
    alt: ""
  })]), _createElementVNode("div", {
    class: "tip"
  }, " 扫一扫，找客服了解更多 ")], -1)), _createElementVNode("div", _hoisted_4, [!$setup.userData ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "item",
    onClick: _cache[1] || (_cache[1] = $event => $setup.nav_toParam('login_m', 2))
  }, "登录/注册 ＞")) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "item",
    onClick: _cache[2] || (_cache[2] = $event => $setup.go('about'))
  }, "关于米檬 ＞"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.go('science'))
  }, "口腔科普 ＞"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[4] || (_cache[4] = $event => $setup.go('news'))
  }, "新闻资讯 ＞"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[5] || (_cache[5] = $event => $setup.go('welfare'))
  }, "公益行动 ＞")]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.textObj.name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($setup.textObj.num), 1), _createElementVNode("div", _hoisted_8, _toDisplayString($setup.textObj.code), 1)])])]);
}